import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/rewind.vue
var s = {
	name: "DtIconRewind",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--rewind"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Rewind",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor",
		"fill-rule": "evenodd",
		"clip-rule": "evenodd"
	}, [...t[0] || (t[0] = [i("path", { d: "M5.72 2.051a.5.5 0 0 1 .28.45v7a.5.5 0 0 1-.807.394l-4.5-3.5a.5.5 0 0 1 0-.79l4.5-3.5a.5.5 0 0 1 .527-.054Zm-3.905 3.95L5 8.477V3.522L1.815 6Z" }, null, -1), i("path", { d: "M11.22 2.051a.5.5 0 0 1 .28.45v7a.5.5 0 0 1-.807.394l-4.5-3.5a.5.5 0 0 1 0-.79l4.5-3.5a.5.5 0 0 1 .527-.054Zm-3.905 3.95L10.5 8.477V3.522L7.315 6Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=rewind.js.map